import { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";

/**
 * Custom hook to redirect to /networks if the network ID is invalid or undefined
 * @param id - The network ID to validate
 * @param redirectOnMount - Whether to redirect immediately on mount (default: true)
 * @returns Object with validation function and redirect function
 */
export const useNetworkIdRedirect = (id: string | undefined, redirectOnMount: boolean = true) => {
    const history = useHistory();

    /**
     * Validates the network ID and redirects if invalid
     * @returns true if ID is valid, false if redirected
     */
    const validateAndRedirect = useCallback((): boolean => {
        if (!id || id === 'undefined') {
            history.replace('/networks');
            return false;
        }
        return true;
    }, [id, history]);

    // Redirect on mount if enabled
    useEffect(() => {
        if (redirectOnMount) {
            validateAndRedirect();
        }
    }, [redirectOnMount, validateAndRedirect]);

    return {
        validateAndRedirect,
        isValid: id && id !== 'undefined',
    };
};

